import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import "react-phone-input-2/lib/style.css";
import RouterData from "./router";

function App() {
  const publicRoutes = RouterData.filter((item) => item.type === "public");
  const privateRoutes = RouterData.filter((item) => item.type === "private");
  // console.log(privateRoutes,"privateRoutes")

  // useEffect(() => {
  //   if (location.pathname === "/" && !access_token) {
  //     const element = document.createElement("a");
  //     // element.href = "https://tellarnie.com/";
  //     element.href = "/login";

  //     element.click();
  //   }
  // }, []);

  return (
    <Routes>
      {publicRoutes.map((curElm, index) => (
        <Route key={index} path={curElm.path} element={curElm.element} />
      ))}

      {privateRoutes.map((curElm, index) => (
        <Route key={index} path={curElm.path} element={curElm.element} />
      ))}
    </Routes>
  );
}
export default App;
